namespace GeniuzPOS.Product {
    export interface CsBrandTypeRow {
        Id?: number;
        BrandTypeCode?: string;
        BrandTypeName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        IsActive?: number;
        FullName?: string;
    }

    export namespace CsBrandTypeRow {
        export const idProperty = 'BrandTypeCode';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Product.CsBrandType';
        export const lookupKey = 'Product.CsBrandType';

        export function getLookup(): Q.Lookup<CsBrandTypeRow> {
            return Q.getLookup<CsBrandTypeRow>('Product.CsBrandType');
        }
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:BrandType:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:BrandType:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:BrandType:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:BrandType:Modify';

        export declare const enum Fields {
            Id = "Id",
            BrandTypeCode = "BrandTypeCode",
            BrandTypeName = "BrandTypeName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            IsActive = "IsActive",
            FullName = "FullName"
        }
    }
}
